import { ENDPOINTS } from "@/settings/api-settings";
import { AxiosResponse } from "axios";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function listProductsClientUnitsProdutsReport(): Observable<any> {
  return from(
    apiClient.get(ENDPOINTS.CLIENT_UNITS_PRODUTS_REPORT_PRODUCTS),
  ).pipe(map((r: any) => r.data || {}));
}

export function listDataClientUnitsProdutsReport(filters: any): Observable<any> {
  return from(
    apiClient.get(ENDPOINTS.CLIENT_UNITS_PRODUTS_REPORT, filters),
  ).pipe(map((r: any) => r.data || {}));
}

export function buildClientUnitsProdutsXlsReport(filters: any): Observable<AxiosResponse> {
  return from(
    apiClient.download(ENDPOINTS.CLIENT_UNITS_PRODUTS_REPORT_XLS, filters),
  );
}
